import type { RouteObject } from "react-router";

const routeModuleCache = new Map<string, Promise<any>>();

const routeComponentLoaders: Record<string, () => Promise<any>> = {
	"/pages/dashboard": () => import("@/pages/dashboard"),
	"/pages/zyusetu/homepage": () => import("@/pages/zyusetu/homepage"),
	"/pages/zyusetu/create": () => import("@/pages/zyusetu/create"),
	"/pages/zyusetu/detail": () => import("@/pages/zyusetu/detail"),
	"/pages/template": () => import("@/pages/template"),
	"/pages/company": () => import("@/pages/company"),
	"/pages/company/subscriptions": () => import("@/pages/company/subscriptions"),
	"/pages/company/contacts": () => import("@/pages/company/contacts"),
	"/pages/company/detail": () => import("@/pages/company/detail"),
	"/pages/company/fee-record-detail": () => import("@/pages/company/fee-record-detail"),
	"/pages/fee": () => import("@/pages/fee"),
	"/pages/fee/operation-log": () => import("@/pages/fee/operation-log"),
	"/pages/fee/operation-log-detail": () => import("@/pages/fee/operation-log-detail"),
	"/pages/management/system/user": () => import("@/pages/management/system/user"),
	"/pages/management/system/user/detail": () => import("@/pages/management/system/user/detail"),
	"/pages/management/system/role/index": () => import("@/pages/management/system/role/index"),
	"/pages/management/system/role/form": () => import("@/pages/management/system/role/form"),
	"/pages/management/user/account": () => import("@/pages/management/user/account"),
	"/pages/data-assets/file-library": () => import("@/pages/data-assets/file-library"),
	"/pages/data-assets/tools-library": () => import("@/pages/data-assets/tools-library"),
	"/pages/data-assets/compliance-knowledge-base": () => import("@/pages/data-assets/compliance-knowledge-base"),
	"/pages/data-operations/knowledge-review": () => import("@/pages/data-operations/knowledge-review"),
	"/pages/customer": () => import("@/pages/customer"),
	"/pages/customer/create": () => import("@/pages/customer/create"),
	"/pages/customer/detail": () => import("@/pages/customer/detail"),
	"/pages/house": () => import("@/pages/house"),
	"/pages/house/create": () => import("@/pages/house/create"),
	"/pages/transaction/company": () => import("@/pages/transaction/company"),
	"/pages/transaction/company/detail": () => import("@/pages/transaction/company/detail"),
	"/pages/transaction/realtor": () => import("@/pages/transaction/realtor"),
	"/pages/transaction/realtor/detail": () => import("@/pages/transaction/realtor/detail"),
	"/pages/transaction/association": () => import("@/pages/transaction/association"),
	"/pages/transaction/association/detail": () => import("@/pages/transaction/association/detail"),
	"/pages/sys/others/contact": () => import("@/pages/sys/others/contact"),
	"/pages/sys/others/faq": () => import("@/pages/sys/others/faq"),
	"/pages/sys/others/guide": () => import("@/pages/sys/others/guide"),
};

const resolveImportFn = (path = "") => {
	if (!path) return null;
	return routeComponentLoaders[path] || null;
};

const loadRouteModule = (path: string) => {
	const cached = routeModuleCache.get(path);
	if (cached) return cached;

	const importFn = resolveImportFn(path);
	if (!importFn) {
		console.warn("Component not found for path:", path);
		return null;
	}

	const next = (importFn as () => Promise<any>)();
	routeModuleCache.set(path, next);
	return next;
};

export const lazyRoute = (path = "", props?: Record<string, unknown>): Pick<RouteObject, "lazy"> => ({
	lazy: async () => {
		const routeModule = await loadRouteModule(path);
		if (!routeModule?.default) {
			return {
				Component: () => null,
			};
		}

		const LoadedComponent = routeModule.default as React.ComponentType<any>;
		const RouteComponent = (routeProps: Record<string, unknown>) => <LoadedComponent {...routeProps} {...props} />;
		RouteComponent.displayName = `LazyRoute(${path})`;

		return {
			Component: RouteComponent,
		};
	},
});
